import { useState, useCallback } from 'react';

const useCalendarFooterTouchHandlers = (setCalendarViewLocal) => {
    const [touchStart, setTouchStart] = useState(0);
    const [touchEnd, setTouchEnd] = useState(0);

    const handleTouchStart = useCallback((e) => {
        setTouchStart(e.targetTouches[0].clientY);
    }, []);

    const handleTouchMove = useCallback((e) => {
        setTouchEnd(e.targetTouches[0].clientY);
    }, []);

    const handleTouchEnd = useCallback(() => {
        if (touchStart > touchEnd + 5) {
            setCalendarViewLocal('Week');
        } else if (touchStart < touchEnd - 5) {
            setCalendarViewLocal('Month');
        }
    }, [touchStart, touchEnd, setCalendarViewLocal]);

    return {
        touchStart,
        touchEnd,
        handleTouchStart,
        handleTouchMove,
        handleTouchEnd,
    };
};

export default useCalendarFooterTouchHandlers;
